<template>
  <div class="content-body">
    <div class="content-inside">
      <div class="modal-form">
        <b-form>
          <div v-if="env === 'local' || env === 'Canary'">
            <b-row class="mb-3">
              <b-col md="3">
                <span class="main-label"> Display Mechanics Tab </span>
                <i class="guide-tooltip" id="display-mechanics-tab-popover"></i>
                <b-popover
                  target="display-mechanics-tab-popover"
                  triggers="hover"
                  content="Toggle display of mechanics tab"
                />
              </b-col>
              <b-col md="7">
                <switches
                  v-model="displayMechanicsTab"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  text-enabled="On"
                  text-disabled="Off"
                  style="position: absolute; top: -15px"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="9"><hr /></b-col>
            </b-row>
          </div>
          <b-row>
            <b-col sm="12" md="3">
              <h6 class="main-label">Title</h6>
            </b-col>
            <b-col sm="12" md="7">
              <b-form-group
                id="titleGroup"
                label="Title"
                label-for="titleGroup"
                class="secondary-label"
                :invalid-feedback="errorMessage('title')"
                :state="isValid('title')"
              >
                <b-form-input
                  id="title"
                  type="text"
                  v-model="guidelines.title"
                  required
                  maxlength="50"
                  :readonly="!displayMechanicsTab"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="9"><hr /></b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="3">
              <h6 class="main-label">Guidelines</h6>
            </b-col>
            <b-col sm="12" md="7">
              <b-form-group
                id="guidelinesGroup"
                :label="guidelinesLabel"
                label-for="guidelines"
                class="secondary-label"
                :invalid-feedback="errorMessage('description')"
                :state="isValid('description')"
              >
                <b-form-textarea
                  id="guidelines"
                  v-model="guidelines.description"
                  placeholder="Enter guidelines"
                  :rows="6"
                  :maxlength="guidelinesMaxLength"
                  :max-rows="6"
                  :readonly="!displayMechanicsTab"
                >
                </b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="9"><hr /></b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="3">
              <h6 class="main-label">Banner</h6>
              <span class="label-helper d-inline-block">(320 x 192)</span>
            </b-col>
            <b-col sm="12" md="7">
              <b-form-group
                class="secondary-label"
                :invalid-feedback="errorMessage('image')"
                :state="isValid('image')"
              >
                <div
                  id="guidelines-upload-image"
                  class="border"
                  @click="
                    displayMechanicsTab
                      ? $root.$emit('bv::show::modal', 'guidelinesUploadImage')
                      : null
                  "
                >
                  <!-- Use an if else here for showing an image -->
                  <!-- <img src="../../assets/images/sample-badge.png" alt="Sample Badge"> -->
                  <img
                    v-if="displayImage !== ''"
                    :src="displayImage"
                    alt="Sample Brand Image"
                  />
                  <div class="upload-icon rounded-circle border"></div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="9"><hr /></b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="2">
              <b-button
                :disabled="saving || !displayMechanicsTab"
                size="lg"
                variant="primary"
                class="save-button btn-block"
                @click="handleSave"
              >
                {{ this.saving ? "Saving..." : "Save" }}
              </b-button>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-form>
        <b-modal
          id="guidelinesUploadImage"
          title="Upload Image"
          no-close-on-backdrop
        >
          <div id="guidelines-image-upload-container" class="border mx-auto">
            <croppa
              v-model="croppa"
              @new-image-drawn="onNewImage"
              @zoom="onZoom"
              :width="320"
              :height="192"
              placeholder="Choose an Image"
              :show-remove-button="true"
              :placeholder-font-size="14"
              remove-button-color="#ff8828"
            >
            </croppa>
          </div>
          <div id="guidelines-image-range-container" class="mx-auto mt-2">
            <input
              type="range"
              class="custom-range"
              id="customRange1"
              @input="onSliderChange"
              :min="sliderMin"
              :max="sliderMax"
              step=".001"
              v-model="sliderVal"
            />
          </div>
          <div slot="modal-footer">
            <b-button
              variant="ghost"
              class="btn-cancel"
              style="margin-right: 0.25rem"
              @click="cancelImage"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              style="margin-left: 0.25rem"
              @click="saveImage"
            >
              Save
            </b-button>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Switches from "vue-switches";
export default {
  name: "guidelines",
  data() {
    return {
      guidelinesMaxLength: 1000,
      croppa: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      saving: false,
      croppaImageBanner: null,
      displayImage: "",
      displayMechanicsTab: true,
      env: process.env.VUE_APP_MODE,
    };
  },
  computed: {
    ...mapState("mechanicsGuidelines", ["loading", "errors", "guidelines"]),
    guidelinesLabel: {
      get: function () {
        if (this.guidelines.description != null) {
          return (
            this.guidelines.description.length +
            " / " +
            this.guidelinesMaxLength
          );
        }
        return "0 / " + this.guidelinesMaxLength;
      },
    },
  },
  created() {
    this.initPage();
  },
  methods: {
    async handleSave() {
      this.saving = true;
      await this.$store.commit("mechanicsGuidelines/errors", null);
      let guidelines = {
        title: this.guidelines.title,
        description: this.guidelines.description,
      };
      if (this.croppaImageBanner !== null) {
        guidelines.image = this.croppaImageBanner.replace(
          /data:image\/png;base64,/gi,
          ""
        );
      }
      this.$store
        .dispatch("mechanicsGuidelines/saveGuidelines", guidelines)
        .then(() => {
          this.saving = false;
          this.croppa.remove();
          this.croppaImageBanner = null;
        });
    },
    async initPage() {
      await this.$store
        .dispatch("mechanicsGuidelines/getGuidelines")
        .then((response) => {
          if (response.guideline != null) {
            this.displayImage = response.guideline.image;
          }
        });
    },
    cancelImage() {
      this.hideModal("guidelinesUploadImage");
      this.croppa.remove();
    },
    saveImage() {
      if (this.croppa.generateDataUrl() === "") {
        return false;
      }
      this.hideModal("guidelinesUploadImage");
      this.croppaImageBanner = this.croppa.generateDataUrl();
      this.displayImage = this.croppaImageBanner;
    },
    hideModal(modal) {
      this.$root.$emit("bv::hide::modal", modal);
    },
    showModal(modal) {
      this.$root.$emit("bv::show::modal", modal);
    },
    onNewImage() {
      this.sliderVal = this.croppa.scaleRatio;
      this.sliderMin = this.croppa.scaleRatio / 2;
      this.sliderMax = this.croppa.scaleRatio * 2;
    },
    onSliderChange(evt) {
      let increment = evt.target.value;
      this.croppa.scaleRatio = +increment;
    },
    onZoom() {
      this.sliderVal = this.croppa.scaleRatio;
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return this.errors.errors[field] ? false : true;
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }
      return this.errors.errors[field];
    },
  },
  components: {
    Switches,
  },
};
</script>

<style lang="scss" scoped>
</style>
